<template>
  <pt-create-report-unscramble-apply class="pt-create-report-unscramble-apply__page"></pt-create-report-unscramble-apply>
</template>

<script>
import PtCreateReportUnscrambleApply from 'cps/lab-order/pt-create-report-unscramble-apply/withData'
export default {
  name: 'pt-create-report-unscramble-apply__view',
  components: {
    'pt-create-report-unscramble-apply': PtCreateReportUnscrambleApply
  }
}
</script>
